import { useGetPartnerQuery } from '@/api/api.slice.tsx';
import { StepPaymentForm } from '@/features/OnBoarding/StepPayment/StepPaymentForm.tsx';
import {
  Alert,
  Loader,
  getMessageFromError,
} from '@arsnovasystems/ars-front-lib';

/**
 * Step payment
 *
 * @returns JSX of the component
 */
export const StepPayment = () => {
  const partnerQueryResult = useGetPartnerQuery();

  if (partnerQueryResult.isLoading || partnerQueryResult.data === undefined) {
    return <Loader />;
  }
  return (
    <>
      <StepPaymentForm me={partnerQueryResult.data} />
      {partnerQueryResult.error ?
        <Alert>{getMessageFromError(partnerQueryResult.error)}</Alert>
      : null}
    </>
  );
};
